export default [
    {
        path: 'reports',
        name: 'reports',
        redirect: { name: 'active-program-census' },
        component: () => import('../views/ReportsPage.vue'),
        children: [
            {
                path: 'services-report',
                name: 'services-report',
                meta: { label: 'Services report' },
                component: () => import('../views/reportsLibrary/ServicesReportPage.vue'),
                props: true,
            },
            {
                path: 'active-program-census',
                name: 'active-program-census',
                meta: { label: 'Active program census' },
                component: () => import('../views/reportsLibrary/CensusReportPage.vue'),
                props: true,
            },
            {
                path: 'admissions-report/:activeDialog?/:activeId?/:activeGroupId?',
                name: 'admissions-report',
                meta: { label: 'Admissions report' },
                component: () => import('../views/reportsLibrary/AdmissionsReportPage.vue'),
                props: true,
            },
        ],
    },
];
